import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.use(ElementUI);

Vue.prototype.$myGlobalVar = '海斛币';
Vue.prototype.$myGlobalVarTitle = '海斛商品';
Vue.prototype.$myGlobalPoint = '海金';

Vue.config.productionTip = false
if(window.location.host.includes('bgjtsvip.com')){
  Vue.prototype.location_url = 'https://openapi.bgjtsvip.com/merchant/uploadImage'
}else{
  Vue.prototype.location_url = 'https://xh.hnbake.com/merchant/uploadImage'
}

Vue.prototype.message_red = 0

const currentURL = window.location.href;
const parameterMatch = currentURL.match(/\?(.*)/);

if (parameterMatch) {
  const queryString = parameterMatch[1];
  const parts = queryString.split('=');
  let str = parts[1].slice(0, -2);
  if(parts && parts.includes('token')){
    if(str){
      localStorage.setItem('token_merchant',str)
      setTimeout(() => {
        window.location.href='http://merchant.bgjtsvip.com/#/stores'
      }, 500);
    }
  }
}


new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

